import { render, staticRenderFns } from "./bracket_roundRobin_table_match.vue?vue&type=template&id=6c62cfb0"
import script from "./bracket_roundRobin_table_match.vue?vue&type=script&lang=js"
export * from "./bracket_roundRobin_table_match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports